import {
  GET_DETAIL_THUCHI,
  GET_DETAIL_THUCHI_SUCCESS,
  GET_DETAIL_THUCHI_FAILURE,
  POST_THANHTOAN_FAILURE,
  POST_THANHTOAN,
  POST_THANHTOAN_SUCCESS,
  DELETE_THANHTOAN_FAILURE,
  DELETE_THANHTOAN,
  DELETE_THANHTOAN_SUCCESS,
  UPDATE_OBJ_THANHTOAN,
  UPDATE_OBJVALUE_THANHTOAN,
  POST_THANHTOAN_ALL,
} from 'actions/QuanLyThuChi/actionTypes';
import { currentDate } from 'utils/formatDate';

const initialState = {
  getDetailThuChiLoading: false,
  posts: [],
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
  totalRow: 0,
  postThanhToanChoVayLoading: false,
  tattoanhopdong:0,
  objThanhToan: {
    CustomerName: '',
    NgayThanhToan: currentDate(),
    SoTien: 0,
    PhiKhac: 0,
    PhiKho: 0,
    GhiChu: '',
    DoiKy: false,
    soNgayQuanHan: 0,
    ngayBatDau: '',
    SoTienPhaiDong: 0,
    KenhThanhToan: 0,
  },
};
const updateObjThanhToan = (state, action) => ({
  ...state,
  getDetailThuChiLoading: true,
  objThanhToan: {
    ...state,
    ...action.payload,
    KenhThanhToan: 0,
  },
});
const updateValueObjThanhToan = (state, action) => {
  return {
    ...state,
    getDetailThuChiLoading: true,
    objThanhToan: {
      ...state.objThanhToan,
      SoTien: action.payload.laiDenNgay,
      PhiKho: action.payload.phiKho,
      soNgayQuanHan: action.payload.soNgayQuanHan,
      ngayBatDau: action.payload.ngayBatDau,
      SoTienPhaiDong: action.payload.laiDenNgay,
      PhiPhatTraLai: action.payload.phiphatchamlai ,
      PhiDongLaiCham: action.payload.PhiDongLaiCham
    },
  };
};
const getDetailThuChi = (state, action) => ({
  ...state,
  getDetailThuChiLoading: true,
});

const getDetailThuChiSuccess = (state, action) => {
  return {
    ...state,
    getDetailThuChiLoading: false,
    objList: action.payload,
  };
};

const getDetailThuChiFailed = (state, action) => ({
  ...state,
  getDetailThuChiLoading: false,
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
});

// lan dong lai
const postThanhToanChoVay = (state, action) => ({
  ...state,
  postThanhToanChoVayLoading: true,
});

const postThanhToanAllChoVay = (state, action) => ({
  ...state,
  postThanhToanChoVayLoading: true,
});
const postThanhToanChoVaySuccess = (state, action) => {
  return {
    ...state,
    postThanhToanChoVayLoading: false,
  };
};

const postThanhToanChoVayFailed = (state, action) => ({
  ...state,
  postThanhToanChoVayLoading: false,
});

const deleteThanhToanChoVay = (state, action) => ({
  ...state,
  deleteThanhToanChoVayLoading: true,
});

const deleteThanhToanChoVaySuccess = (state, action) => {
  return {
    ...state,
    deleteThanhToanChoVayLoading: false,
    deleteThanhToan: action.payload,
  };
};

const deleteThanhToanChoVayFailed = (state, action) => ({
  ...state,
  deleteThanhToanChoVayLoading: false,
  deleteThanhToan: false,
});

const quanLyChoVayReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DETAIL_THUCHI:
      return getDetailThuChi(state, action);
    case GET_DETAIL_THUCHI_SUCCESS:
      return getDetailThuChiSuccess(state, action);
    case GET_DETAIL_THUCHI_FAILURE:
      return getDetailThuChiFailed(state, action);
    case POST_THANHTOAN:
      return postThanhToanChoVay(state, action);
    case POST_THANHTOAN_ALL:
      return postThanhToanAllChoVay(state, action);
    case POST_THANHTOAN_SUCCESS:
      return postThanhToanChoVaySuccess(state, action);
    case POST_THANHTOAN_FAILURE:
      return postThanhToanChoVayFailed(state, action);
    case DELETE_THANHTOAN:
      return deleteThanhToanChoVay(state, action);
    case DELETE_THANHTOAN_SUCCESS:
      return deleteThanhToanChoVaySuccess(state, action);
    case DELETE_THANHTOAN_FAILURE:
      return deleteThanhToanChoVayFailed(state, action);
    case UPDATE_OBJ_THANHTOAN:
      return updateObjThanhToan(state, action);
    case UPDATE_OBJVALUE_THANHTOAN:
      return updateValueObjThanhToan(state, action);
    default:
      return state;
  }
};

export default quanLyChoVayReducer;
